module.exports = __webpack_public_path__ + "static/results_mob_preview_en-US-dbc23313cb19d09e6410d063b2d65bf1.png";